import { Button } from "primereact/button";
import React from "react";
import { useDispatch } from "react-redux";
import { setIsEditProfilePopupOpen } from "src/redux/slices/bMCProfileSlice";
import { ReactComponent as PenIcon } from "../../assets/icons/pen.svg";
import { useTranslation } from "react-i18next";

const EditProfileButton = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation(["common"]);
  const handleUpdateProfile = () => {
    dispatch(setIsEditProfilePopupOpen(true) as any);
  };
  return (
    <div className="d-flex gap-2 align-items-center edit-profile-btn">
      <Button className="light-primary-btn " onClick={handleUpdateProfile}>
        <PenIcon /> {t("updateProfile")}
      </Button>
    </div>
  );
};

export default EditProfileButton;
